export default "__VITE_ASSET__AsF1p3$a__"